import React from 'react';
import { Link } from 'react-router-dom';
import { MdEvent, MdBusiness } from 'react-icons/md';
import { FaPlaceOfWorship } from 'react-icons/fa'; // Importing a suitable icon for Temple Registration

const PartnerModal = ({
  isVisible,
  onClose,
  handleVenueRegistration,
  handleEventRegistration // Add handler for temple registration
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-lg relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl"
        >
          &times;
        </button>
        
        {/* Modal Title */}
        <h2 className="text-2xl font-extrabold mb-6 text-center">
          Select the service you want to register for
        </h2>
        
        {/* Registration Options */}
        <div className="space-y-4">
          {/* Venue Registration */}
          <div
            className="flex items-center p-5 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg shadow-lg hover:bg-gray-300 cursor-pointer transition transform hover:scale-105"
            onClick={handleVenueRegistration}
          >
            <MdBusiness className="text-4xl text-yellow-600 mr-4" />
            <div>
              <h3 className="text-xl font-semibold text-gray-800">Venue Registration</h3>
              <p className="text-sm text-gray-600">Register your venue on our platform</p>
              Register now
            </div>
          </div>
          
          {/* Event Registration */}
          <div
            className="flex items-center p-5 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg shadow-lg hover:bg-gray-300 cursor-pointer transition transform hover:scale-105"
            onClick={handleEventRegistration}
          >
            <MdEvent className="text-4xl text-yellow-600 mr-4" />
            <div>
              <h3 className="text-xl font-semibold text-gray-800">Event Registration</h3>
              <p className="text-sm text-gray-600">Register to create events for students</p>
              Register now
            </div>
          </div>
          
          {/* Temple Registration */}
          {/*<div
            className="flex items-center p-5 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg shadow-lg hover:bg-gray-300 cursor-pointer transition transform hover:scale-105"
            onClick={handleTempleRegistration} // Add temple handler
          >
            <FaPlaceOfWorship className="text-4xl text-yellow-600 mr-4" />
            <div>
              <h3 className="text-xl font-semibold text-gray-800">Temple Registration</h3>
              <p className="text-sm text-gray-600">Register your temple on our platform</p>
              Register now
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PartnerModal;
